/**
 * Client component to initialize keywords store on app startup
 * Place this in your root layout to load keywords once when app mounts
 */

'use client'

import { useKeywordsInit } from '@/lib/use-keywords-init'

export function KeywordsInitializer() {
  useKeywordsInit()
  return null
}

